import { Injectable, signal } from '@angular/core';

interface UISettings {
  sidebarCollapsed: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private readonly SETTINGS_KEY = 'ui_settings';
  private defaultSettings: UISettings = {
    sidebarCollapsed: false
  };

  // Signal to track sidebar collapsed state
  sidebarCollapsed = signal(this.loadSidebarCollapsed());

  constructor() {
    // Инициализация с сохраненными настройками
    const savedSettings = this.loadSettings();
    this.sidebarCollapsed.set(savedSettings.sidebarCollapsed);
  }

  toggleSidebarCollapsed(): void {
    this.sidebarCollapsed.update(collapsed => {
      const newState = !collapsed;
      this.saveSidebarCollapsed(newState);
      return newState;
    });
  }

  setSidebarCollapsed(collapsed: boolean): void {
    this.sidebarCollapsed.set(collapsed);
    this.saveSidebarCollapsed(collapsed);
  }

  getSidebarCollapsed(): boolean {
    return this.sidebarCollapsed();
  }

  private loadSettings(): UISettings {
    try {
      const saved = localStorage.getItem(this.SETTINGS_KEY);
      if (saved) {
        const parsed = JSON.parse(saved);
        return { ...this.defaultSettings, ...parsed };
      }
    } catch (error) {
      console.warn('Failed to load UI settings from localStorage:', error);
    }
    return { ...this.defaultSettings };
  }

  private saveSettings(settings: UISettings): void {
    try {
      localStorage.setItem(this.SETTINGS_KEY, JSON.stringify(settings));
    } catch (error) {
      console.warn('Failed to save UI settings to localStorage:', error);
    }
  }

  private loadSidebarCollapsed(): boolean {
    return this.loadSettings().sidebarCollapsed;
  }

  private saveSidebarCollapsed(collapsed: boolean): void {
    const currentSettings = this.loadSettings();
    this.saveSettings({ ...currentSettings, sidebarCollapsed: collapsed });
  }
}